import { useTranslation } from "react-i18next";

/**
 * El respiro entre la card de "horas → minutos" y la card del curso gratis.
 *
 * De ritmo: dos cards seguidas se leen como una lista de cajas y ninguna pesa. Entre
 * medio va tipografía sobre el fondo, sin borde ni sombra, para que cada card vuelva a
 * valer. Por eso es corto — dos frases. Si crece, deja de ser un respiro.
 *
 * De contenido: hace de vendedor del curso gratis que viene justo abajo. Le habla al que
 * no tiene NADA de experiencia con IA y no sabe por dónde arrancar, que es el visitante
 * más común. Una versión anterior comparaba con los tutoriales de internet: eso nos ponía
 * en esa liga y bajaba el precio en vez de subirlo. No volver por ahí.
 */
export function EscalonPuente() {
  const { t } = useTranslation();

  return (
    <section className="relative px-5 py-16 sm:px-8 sm:py-20">
      <div className="mx-auto max-w-[720px] text-center">
        {/* Regla ornamental (patrón 4.5 del manual): puntuación visual, no decoración. */}
        <span
          aria-hidden="true"
          className="mx-auto mb-7 block h-[3px] w-14 rounded-full bg-landing-red"
        />
        <h2 className="font-display text-balance text-[clamp(26px,3.6vw,38px)] font-extrabold leading-[1.15] tracking-tight text-landing-text">
          {t("landing.launch.bridge.title")}
        </h2>
        <p className="mx-auto mt-4 max-w-[54ch] text-pretty text-[16.5px] leading-relaxed text-landing-muted sm:text-[17px]">
          {t("landing.launch.bridge.body")}
        </p>
        {/* Puente físico a la card de abajo: el texto anuncia lo que el ojo va a
            encontrar apenas siga scrolleando. */}
        <p className="font-display mt-3 text-[clamp(17px,2.2vw,20px)] font-extrabold tracking-tight text-landing-red">
          {t("landing.launch.bridge.kicker")}
        </p>
      </div>
    </section>
  );
}
